import { CubeTimeDimensionGranularity } from '../../../enum/cube-schema.enum';

export interface QueryCumulativeAverageDurationsRequestParamsDto {
  appIds: string[];
  startTime: string;
  endTime: string;
  granularity?: CubeTimeDimensionGranularity;
  currentWeekday?: boolean;
}
